export const replaceNewlineCharacters = str => {
    return str
        .replace('\n', '<br/>');
};
